// How long a failure toast stays up. Long enough to read a server validation message.
export const ERROR_TOAST_MS = 8000;

// The message the server sent, or a fallback. A network failure carries no data at all.
export function messageFrom(error: unknown, fallback: string) {
    return (error as { data?: { message?: string } })?.data?.message || fallback;
}

/*
    What to tell an admin whose session expired mid-edit. A 401 means two things — the session has
    gone, or the action was refused — and BackRoyalApi's isNotLoggedInError separates them by the
    `not_logged_in` flag the server sets (application_controller#render_logged_out_error, plus the
    deactivated and deletion-queue cases).

    Angular's $http interceptor showed a sign-in form and retried the request. RTK Query never
    reaches that interceptor, so the most this page can do is say which of the two happened.
*/
export const LOGGED_OUT_DESCRIPTION =
    'Your session has expired. Sign in again in another tab, then save. Your changes are still here.';
